// import CreatePerson from '../Person/CreatePerson'
import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import EditPerson from '../Person/EditPerson'

export default class Editpersoncomponent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			showForm: false,
			isNewLang: false,
			personId: '',
			languageModalVisible: false,
			contentLanguageOptions: [
				{
					label: 'English',
					value: 'En',
					id: 0,
				},
				{
					label: 'Telugu',
					value: 'Te',
					id: 1,
				},
			],
			contentSelectedLangVal: null,
			editPerson: false,
		}
	}

	// handlePersonID = e => {
	// 	const personId = e.target.value
	// 	this.setState({ personId })
	// }

	closeModal = () => {
		this.setState({ languageModalVisible: false })
	}

	editPerson = () => {
		this.setState({ editPerson: true, languageModalVisible: false })
	}

	renderModal = () => {
		const {
			languageModalVisible,
			contentLanguageOptions,
			contentSelectedLangVal,
		} = this.state
		return (
			<Modal show={languageModalVisible} onHide={() => this.closeModal()}>
				<Modal.Body>
					<div className='row'>
						{contentLanguageOptions.map((language, index) => (
							<div key={index}>
								<input
									value={contentSelectedLangVal}
									type='radio'
									checked={
										this.state.contentSelectedLangVal === language.value
									}
									onClick={() => {
										this.changeContentLanguage(language.value)
									}}
								></input>
								<text htmlFor={language.label}>{language.label}</text>
								{/* {contentDetails && contentDetails.contentLanguages
									&& contentDetails.contentLanguages.includes(language.value) ? (
										<text htmlFor='available'>(available)</text>
									) : (
										<text htmlFor='unavailable'>(unavailable)</text>
									)} */}
							</div>
						))}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeModal()}>Cancel</Button>
					<Button onClick={() => this.editPerson()}>Ok</Button>
				</Modal.Footer>
			</Modal>
		)
	}

	handleButtonClick = () => {
		this.setState({ showForm: !this.state.showForm })
	}

	render() {
		return (
			<div className=' row col-md-12'>
				<label htmlFor='text'>person id</label>
				<div>
					<input
						type='text'
						// onChange={e =>
						// 	this.handlePersonId(e)
						// }
						value={this.state.personId}
						placeholder='Please Enter PersonID'
					></input>
				</div>
				{this.renderModal()}
				<div>
					<Button onClick={() => this.handleButtonClick()}>
						Edit person
					</Button>
				</div>
				{/* {this.state.showForm ? (
					<CreatePerson
						isNewLang={this.state.isNewLang}
						editPerson={true}
						contentSelectedLangVal={this.state.contentSelectedLangVal}
					/>
				) : null} */}
				{this.state.showForm ? (
					<EditPerson
						isNewLang={this.state.isNewLang}
						editPerson={true}
						contentSelectedLangVal={this.state.contentSelectedLangVal}
					/>
				) : null}

			</div>
		)
	}
}
